import { createGenericQuery, getGenericQueryKey } from 'js/react_query_helpers/helpers';
const rpcName = 'previews:get_archive_files';
export const makeArchiveFilesRequestPackage = (previewsGetArchiveFiles, previewsLoggedOutGetArchiveFiles) => createGenericQuery({
    queryRouteFilter: ['custom', rpcName],
    queryFn: ({ apiArg, pkgArg }) => async ({}) => {
        const result = await (pkgArg.isLoggedIn
            ? previewsGetArchiveFiles(apiArg, {})
            : previewsLoggedOutGetArchiveFiles(apiArg, {}));
        return { apiData: result, pkgData: null };
    },
    getQueryKey: getGenericQueryKey('custom', rpcName),
});
//# sourceMappingURL=archive_files.preenvesnextjs.map
